// extracted by mini-css-extract-plugin
export default {"modalZ":"100001","headerHeight":"80px","header":"VBi7p","logo":"DQz1d","tablet":"ZmZeJ","desktop":"_Ggvs"};